// extracted by mini-css-extract-plugin
module.exports = {"logo":"partner-logo_logo__Be7ow","grid":"partner-logo_grid__dKaHf"};